/**
 * /wiki/d/:docId/versions — version-history surface.
 *
 * Phase 3a — paginated list of versions (newest first), one-version
 * preview pane, restore-as-draft / restore-and-publish modal.
 *
 * Search param contract:
 *   - `v=<versionId>` selects which version to preview. Default = first
 *     row in the list. Page syncs this param on first load so a hard
 *     refresh comes back to the same row.
 */

import { createFileRoute } from '@tanstack/react-router'

import { VersionsPage } from '@/features/wiki/components/VersionsPage'

interface VersionsSearch {
  v?: string
}

export const Route = createFileRoute('/wiki/d/$docId/versions/')({
  component: VersionsPage,
  validateSearch: (search: Record<string, unknown>): VersionsSearch => ({
    v: typeof search.v === 'string' && search.v.length > 0 ? search.v : undefined,
  }),
})
